import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

const LeftDashboardLoader = () => {
	return (
		<StyledLeftDashboardLoader>
			<section className="skeleton-wrapper">
				<Skeleton circle={false} height={40} width={295} />
				<Skeleton circle={false} height={20} width={295} />
				<Skeleton circle={false} height={20} width={295} />
				<Skeleton circle={false} height={20} width={295} />
				<Skeleton circle={false} height={20} width={295} />
				<Skeleton circle={false} height={20} width={295} />
				<Skeleton circle={false} height={20} width={295} />
			</section>
			<section className="skeleton-wrapper">
				<div className="skeleton-projects">
					<Skeleton className={'skeleton-user'} circle={false} height={20} width={120} />
					<Skeleton circle height={20} width={20} />
					<Skeleton circle height={20} width={20} />
					<Skeleton circle height={20} width={20} />
					<Skeleton className={'skeleton-more'} circle={false} height={20} width={70} />
				</div>
				<div className="skeleton-projects">
					<Skeleton className={'skeleton-user'} circle={false} height={20} width={120} />
					<Skeleton circle height={20} width={20} />
					<Skeleton circle height={20} width={20} />
					<Skeleton circle height={20} width={20} />
					<Skeleton className={'skeleton-more'} circle={false} height={20} width={70} />
				</div>
			</section>
			<section className="skeleton-wrapper skeleton-filter">
				<Skeleton circle={false} height={40} width={295} />
				<Skeleton circle={false} height={20} width={250} />
				<Skeleton circle={false} height={30} width={295} />
				<Skeleton circle={false} height={40} width={295} />
				<Skeleton circle={false} height={40} width={295} />
				<Skeleton circle={false} height={40} width={295} />
				<Skeleton circle={false} height={40} width={295} />
			</section>
		</StyledLeftDashboardLoader>
	);
};

export default LeftDashboardLoader;

const StyledLeftDashboardLoader = styled.section`
	margin-top: 1.5rem;
	padding-left: 0.7rem;
	display: flex;
	flex-direction: column;
	align-content: stretch;
	background-color: ${(props) => props.theme.color[`white`]};
	.skeleton-filter {
		padding-top: 3rem;
	}
	.skeleton-user {
		padding-right: 2rem;
	}
	.skeleton-more {
		padding-left: 2rem;
	}
	.skeleton-projects {
		span:first-child {
			margin-right: 0.5rem;
		}
	}
	.react-loading-skeleton {
		background-color: ${(props) => props.theme.color[`grey250`]};
		background-image: linear-gradient(
			90deg,
			${(props) => props.theme.color[`grey250`]},
			${(props) => props.theme.color[`grey100`]},
			${(props) => props.theme.color[`grey250`]}
		);
	}
`;
